<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Edit Remark"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="editForm"
                :model="editForm"
                :rules="rules"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Last Mile" prop="last_mile" size="small">
                            <el-input
                                readonly
                                size="small"
                                v-model="editForm.last_mile"
                                placeholder="Please input last mile"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Channel Code" prop="channel_code" size="small">
                            <el-select
                                clearable
                                filterable
                                v-model="editForm.channel_code"
                                placeholder="Please select"
                            >
                                <el-option
                                    v-for="item in expressList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.channel_code"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            editForm: {
                last_mile: "",
                channel_code: "",
            },
            expressList:{},
            rules: {
                last_mile: [
                    {
                        required: true,
                        message: "Please input last mile",
                    },
                ],
                channel_code: [
                    {
                        required: true,
                        message: "Please input channel code",
                    },
                ],
            },
        };
    },
    methods: {
        userChange(val){            
            this.editForm.user_id = val;
        },
        closeDialog() {
            this.editForm = {
                last_mile: "",
                channel_code:"",
            };
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .lastMile(
                            {
                                ...this.editForm,
                            },
                            "post",
                            this.tableItem.id
                        )
                        .then((res) => {
                            if (res) {
                                this.loading = false;
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "编辑成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        lastMile() {
            cmofferApi
                .lastMile({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        this.editForm = {
                            last_mile: res.data.last_mile,
                            channel_code: res.data.channel_code,
                        };
                    }
                })
                .catch(() => {});
        },
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        editVisible(val) {
            if (val) {
                this.lastMile();
                cmofferApi
                    .expressSelect({}, "get")
                    .then((res) => {
                        if (res) {
                            this.expressList = res.data;
                        }
                    });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.edit {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }
        .el-select {
            width: 100%;
        }
        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
}
</style>
